import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    autoSubmit: { type: Boolean, default: false }
  }

  connect() {
  }

  input(event) {
    if (!this.autoSubmitValue) return
    this.submitForm()
  }

  keypress(event) {
    if (event.key === "Enter" && this.autoSubmitValue) {
      event.preventDefault()
      this.submitForm()
    }
  }

  blur(event) {
    if (this.autoSubmitValue) {
      this.submitForm()
    }
  }

  submitForm() {
    const input = this.inputTarget
    
    if (!input || input.disabled) return
    
    const form = input.closest('form')
    if (form && input.value !== input.defaultValue) {
      const formId = form.id
      const inputId = input.id
      
      document.addEventListener('turbo:render', () => {
        const updatedForm = document.getElementById(formId)
        if (updatedForm) {
          const updatedInput = updatedForm.querySelector(`#${inputId}`)
          if (updatedInput) {
            updatedInput.focus()
          }
        }
      }, { once: true })

      form.requestSubmit()
    }
  }
}